import * as l from "react";
import { forwardRef as s } from "react";
import * as p from "react-native-web";
import { unstable_createElement as b, StyleSheet as h, View as g } from "react-native-web";
const v = (e) => p.unstable_createElement("option", e);
function E({
  color: e,
  label: t,
  testID: r,
  value: n,
  enabled: a = !0
}) {
  return /* @__PURE__ */ l.createElement(v, {
    disabled: a === !1 ? !0 : void 0,
    style: {
      color: e
    },
    testID: r,
    value: n,
    label: t
  }, t);
}
function o() {
  return o = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, o.apply(this, arguments);
}
const w = /* @__PURE__ */ s((e, t) => b("select", {
  ...e,
  ref: t
})), y = /* @__PURE__ */ s((e, t) => {
  const {
    enabled: r,
    onValueChange: n,
    selectedValue: a,
    itemStyle: V,
    mode: C,
    prompt: S,
    dropdownIconColor: x,
    ...i
  } = e, m = l.useCallback((d) => {
    const {
      selectedIndex: u,
      value: f
    } = d.target;
    n && n(f, u);
  }, [n]);
  return (
    // $FlowFixMe
    /* @__PURE__ */ l.createElement(w, o({
      disabled: r === !1 ? !0 : void 0,
      onChange: m,
      ref: t,
      value: a
    }, i))
  );
});
y.Item = E;
const c = (e) => /* @__PURE__ */ l.createElement(g, {
  style: [I.unimplementedView, e.style]
}, e.children), I = h.create({
  unimplementedView: process.env.NODE_ENV !== "production" ? {
    alignSelf: "flex-start",
    borderColor: "red",
    borderWidth: 1
  } : {}
});
function O() {
  return /* @__PURE__ */ l.createElement(c, null);
}
O.Item = c;
export {
  y as Picker,
  O as PickerIOS
};
